const questionnaireCL = {
  sections: [
    {
      id: 'how_wareclouds_works',
      part: 1,
      videoId: 'dlEWTyiu2PY',
      questions: [
        {
          globalId: '1-1',
          question: '¿Qué es un Warecloud?',
          alternatives: [
            { option: 1, text: 'Un local de ventas' },
            { option: 2, text: 'Una aplicación' },
            { option: 3, text: 'Una bodega en una casa' },
            { option: 4, text: 'Un camión de reparto' },
          ],
          correctOption: 3,
        },
        {
          globalId: '1-2',
          question: '¿Qué función cumple un Clouder?',
          alternatives: [
            { option: 1, text: 'Arma pedidos en bodega' },
            { option: 2, text: 'Entrega los pedidos a los clientes' },
            { option: 3, text: 'Recibe pagos' },
            { option: 4, text: 'Contacta a las marcas' },
          ],
          correctOption: 2,
        },
      ],
    },
    {
      id: 'same_day_service',
      part: 2,
      videoId: 'tRt_YtM4dLU',
      questions: [
        {
          globalId: '2-1',
          question:
            '¿A partir de qué hora se publican las rutas Same Day en la plataforma?',
          alternatives: [
            { option: 1, text: '09:00 am' },
            { option: 2, text: '11:45 am' },
            { option: 3, text: '10:30 am' },
            { option: 4, text: '02:00 pm' },
          ],
          correctOption: 2,
        },
        {
          globalId: '2-2',
          question:
            '¿Cuál es el horario en que se deben realizar las entregas Same Day?',
          alternatives: [
            { option: 1, text: 'Entre 12:00 y 22:00' },
            { option: 2, text: 'Entre 10:00 y 18:00' },
            { option: 3, text: 'Entre 09:00 y 21:00' },
            { option: 4, text: 'No hay horario definido' },
          ],
          correctOption: 1,
        },
        {
          globalId: '2-3',
          question: '¿Qué debes hacer al retirar pedidos en la bodega?',
          alternatives: [
            {
              option: 1,
              text: 'Recibir todos juntos sin verificar',
            },
            { option: 2, text: 'Escanearlos al salir' },
            {
              option: 3,
              text: 'Confiar en el Warecloud sin chequear',
            },
            { option: 4, text: 'Revisar uno por uno en la app' },
          ],
          correctOption: 4,
        },
      ],
    },
    {
      id: 'scheduled_express_service',
      part: 3,
      videoId: 'oK0uUf6Uk9Q',
      questions: [
        {
          globalId: '3-1',
          question: '¿Cuántas franjas horarias existen en Express Agendado?',
          alternatives: [
            { option: 1, text: '2' },
            { option: 2, text: '3' },
            { option: 3, text: '5' },
            { option: 4, text: '4' },
          ],
          correctOption: 3,
        },
        {
          globalId: '3-2',
          question:
            '¿Cuál es la diferencia principal entre Express Agendado y Express?',
          alternatives: [
            {
              option: 1,
              text: 'En Agendado las rutas aparecen todo el día',
            },
            {
              option: 2,
              text: 'En Express Agendado se retira en bodega Wareclouds y en Express en tienda de la marca',
            },
            {
              option: 3,
              text: 'En Express Agendado entregas sin límite de tiempo',
            },
            {
              option: 4,
              text: 'No hay diferencia, funcionan igual',
            },
          ],
          correctOption: 2,
        },
      ],
    },
    {
      id: 'deliveries_and_returns',
      part: 4,
      videoId: 'm7nzaSm8N9k',
      questions: [
        {
          globalId: '4-1',
          question:
            '¿Cuándo deben devolverse los pedidos no entregados de Express Agendado?',
          alternatives: [
            {
              option: 1,
              text: 'Al día hábil siguiente antes de las 11:30',
            },
            {
              option: 2,
              text: 'El mismo día antes de las 22:00',
            },
            { option: 3, text: 'En cualquier momento' },
            {
              option: 4,
              text: 'No es necesario devolverlos',
            },
          ],
          correctOption: 1,
        },
        {
          globalId: '4-2',
          question:
            '¿Qué diferencia principal hay con las devoluciones Express?',
          alternatives: [
            {
              option: 1,
              text: 'Deben hacerse en tienda el mismo día antes de las 17:00',
            },
            {
              option: 2,
              text: 'Tienes 48 horas para devolverlos',
            },
            {
              option: 3,
              text: 'Solo se devuelven si el cliente lo pide',
            },
            { option: 4, text: 'Se pagan siempre' },
          ],
          correctOption: 1,
        },
        {
          globalId: '4-3',
          question:
            '¿Qué debes hacer antes de marcar un pedido como no entregado?',
          alternatives: [
            {
              option: 1,
              text: 'Avisar al equipo que no puedo entregar',
            },
            {
              option: 2,
              text: 'Revisar que la dirección y pedido correspondan',
            },
            {
              option: 3,
              text: 'Llamar al cliente al menos dos veces',
            },
            {
              option: 4,
              text: 'Intentar tocar el timbre o interfono',
            },
          ],
          correctOption: 3,
        },
        {
          globalId: '4-4',
          question: '¿Qué debo hacer al entregar al cliente?',
          alternatives: [
            { option: 1, text: 'Llamar y dejar en la reja' },
            {
              option: 2,
              text: 'Tomar foto clara mostrando la entrega',
            },
            {
              option: 3,
              text: 'Dejarlo con cualquier vecino',
            },
            {
              option: 4,
              text: 'Marcar entregado antes de llamar',
            },
          ],
          correctOption: 2,
        },
      ],
    },
    {
      id: 'rules_and_bonuses',
      part: 5,
      videoId: 'SjNXd_kOWoU',
      questions: [
        {
          globalId: '5-1',
          question: '¿En qué días trabaja Wareclouds?',
          alternatives: [
            { option: 1, text: 'De lunes a domingo' },
            {
              option: 2,
              text: 'De lunes a sábado (excepto festivos)',
            },
            { option: 3, text: 'Solo días hábiles' },
            { option: 4, text: 'Solo fines de semana' },
          ],
          correctOption: 2,
        },
        {
          globalId: '5-2',
          question: '¿Cuándo se emiten las boletas?',
          alternatives: [
            { option: 1, text: 'Cualquier día' },
            { option: 2, text: 'Los días 1 y 16 de cada mes' },
            { option: 3, text: 'Cada lunes' },
            { option: 4, text: 'Solo al final del mes' },
          ],
          correctOption: 2,
        },
        {
          globalId: '5-3',
          question:
            '¿Cuántas rutas en franjas horarias diferentes tengo que hacer para ganar una bonificación extra?',
          alternatives: [
            { option: 1, text: 'Si trabajas fines de semana' },
            { option: 2, text: 'Si entregas pedidos grandes' },
            {
              option: 3,
              text: 'Si haces rutas en al menos 2 franjas horarias el mismo día',
            },
            {
              option: 4,
              text: 'Si trabajas solo en comunas específicas',
            },
          ],
          correctOption: 3,
        },
      ],
    },
  ],
};

export default questionnaireCL;
